// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! muse-css:product:DDp6gk */\n.mYYDp{display:flex;margin-top:calc(var(--header-h)*-1);min-height:100svh;overflow:hidden;padding-top:var(--header-h);position:relative}._6--GA{bottom:0;height:100%;left:0;-o-object-fit:cover;object-fit:cover;position:absolute;right:0;top:0;width:100%}.UcK1D{backdrop-filter:blur(40px);background-color:var(--audio-overlay-image);bottom:0;left:0;position:absolute;right:0;top:0}._5YmtN{color:var(--audio-exception-light);display:flex;flex:1;flex-direction:column;font-family:var(--font-muse-sans);position:relative;width:100%}@media (min-width:1280px){._5YmtN{margin:0 auto;max-width:var(--audio-layout-xl)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hero": "mYYDp",
	"background": "_6--GA",
	"overlay": "UcK1D",
	"layout": "_5YmtN"
};
export default ___CSS_LOADER_EXPORT___;
